import { CatalogTableColumnsBindingResult } from 'src/templates/queries/catalogPrimaryKeyTableColumns';
import { DATA_SOURCE_PREFIX } from 'src/templates/queries/iris';

export type CatalogColumnEntry = {
  iri: string;
  name: string;
};

export type CatalogTableEntry = {
  iri: string;
  name: string;
  catalog?: string;
  schema?: string;
  dataSources: string[];
  columnsByIri: Record<string, CatalogColumnEntry>;
};

const getDataSourceIdFromIri = (iri: string) =>
  iri.replace(new RegExp(`^${DATA_SOURCE_PREFIX}`), '');

export const parseDataSourceTableColumns = (
  rows: CatalogTableColumnsBindingResult[]
) => {
  const tablesByIri: Record<string, CatalogTableEntry> = {};
  rows.forEach((row) => {
    let existingEntry = tablesByIri[row.table.value];
    const dataSourceName = getDataSourceIdFromIri(row.dataSource.value);

    if (!existingEntry) {
      existingEntry = {
        iri: row.table.value,
        name: row.tableName.value,
        catalog: row.catalogName?.value,
        schema: row.schemaName?.value,
        dataSources: [dataSourceName],
        columnsByIri: {},
      };
      tablesByIri[row.table.value] = existingEntry;
    } else if (!existingEntry.dataSources.includes(dataSourceName)) {
      existingEntry.dataSources.push(dataSourceName);
    }

    existingEntry.columnsByIri[row.column.value] = {
      iri: row.column.value,
      name: row.columnName.value,
    };
  });

  return tablesByIri;
};
